
import { Component, Prop, Vue } from 'vue-property-decorator';
import { WebsiteComposite, WebsiteStatus } from '@/services/Website/interfaces';
import StatusChip from '@/components/layout/StatusChip.vue';

@Component({
  components: { StatusChip },
})
export default class ToggleWebsitePanel extends Vue {
  @Prop({ type: Object, required: true })
  public composite!: WebsiteComposite;

  @Prop({ type: Boolean, default: false })
  public busy!: boolean;

  @Prop({ type: String, default: '' })
  public errorMessage!: string;

  public get domain(): string {
    return this.composite.website.domain;
  }

  public get currentStatus(): string {
    return this.composite.website.status;
  }

  public get targetStatus(): string {
    return this.currentStatus === WebsiteStatus.ACTIVE ? WebsiteStatus.DISABLED : WebsiteStatus.ACTIVE;
  }

  public get actionVerb(): string {
    return this.targetStatus === WebsiteStatus.ACTIVE ? 'Enable' : 'Disable';
  }

  public onSubmit(): void {
    this.$emit('submit', { status: this.targetStatus });
  }
}
